import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from '../../containers/Text';
import './HomePage.scss';
import { CheckCircle } from 'lucide-react';

const ServicesInfoSection = () => {
  const { t } = useTranslation();

  return (
    <div className="services-info-section">
      {/* Our Services */}
      <div className="services-card">
        <h3 className="services-title">
          <Text text={t('our-services-title')} />
        </h3>
        <ul className="services-list">
          <li className="service-item">
            <Text
              text={
                <CheckCircle className='service-check-icon' />
              }
            />
            <span className="service-text">
              <span className="service-bold">
                <Text text={t('financial-treatment-title')} />
              </span>
              <Text text={t('financial-treatment-description')} />
            </span>
          </li>
          <li className="service-item">
            <Text
              text={
                <CheckCircle className='service-check-icon' />
              }
            />
            <span className="service-text">
              <span className="service-bold">
                <Text text={t('social-rights-title')} />
              </span>
              <Text text={t('social-rights-description')} />
            </span>
          </li>
          <li className="service-item">
            <Text
              text={
                <CheckCircle className='service-check-icon' />
              }
            />
            <span className="service-text">
              <span className="service-bold">
                <Text text={t('professional-consultation-title')} />
              </span>
              <Text text={t('professional-consultation-description')} />
            </span>
          </li>
        </ul>
      </div>

      {/* Important to Know */}
      <div className="important-info-card">
        <h3 className="important-title">
          <Text text={t('important-to-know-title')} />
        </h3>
        <ul className="important-list">
          <li className="important-item">
            <Text
              text={
                <i
                  data-lucide="info"
                  className="important-info-icon w-6 h-6 text-blue-500"
                />
              }
            />
            <span className="important-text">
              <span className="important-bold">
                <Text text={t('managed-forms-title')} />
              </span>
              <Text text={t('managed-forms-description')} />
            </span>
          </li>
          <li className="important-item">
            <Text
              text={
                <i
                  data-lucide="info"
                  className="important-info-icon w-6 h-6 text-blue-500"
                />
              }
            />
            <span className="important-text">
              <span className="important-bold">
                <Text text={t('tracking-updates-title')} />
              </span>
              <Text text={t('tracking-updates-description')} />
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ServicesInfoSection;
